/**
 * @generated SignedSource<<5788234b60a25b1a484b223bdb185f36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormsOrderQuestionsMutationInput = {
  clientMutationId?: string | null;
  formId: string;
  questionIdsInOrder: ReadonlyArray<string>;
};
export type EditForm_orderQuestions_Mutation$variables = {
  input: FormsOrderQuestionsMutationInput;
};
export type EditForm_orderQuestions_Mutation$data = {
  readonly orderQuestions: {
    readonly form: {
      readonly " $fragmentSpreads": FragmentRefs<"EditForm_form">;
    };
  } | null;
};
export type EditForm_orderQuestions_Mutation = {
  response: EditForm_orderQuestions_Mutation$data;
  variables: EditForm_orderQuestions_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CustomField__FieldOption",
    "kind": "LinkedField",
    "name": "options",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditForm_orderQuestions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsOrderQuestionsMutationPayload",
        "kind": "LinkedField",
        "name": "orderQuestions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "form",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditForm_form"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditForm_orderQuestions_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FormsOrderQuestionsMutationPayload",
        "kind": "LinkedField",
        "name": "orderQuestions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Form",
            "kind": "LinkedField",
            "name": "form",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isClosed",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FormQuestion",
                "kind": "LinkedField",
                "name": "questions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "definition",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maxValue",
                            "storageKey": null
                          }
                        ],
                        "type": "CustomField__Numeric",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "CustomField__Checkboxes",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v4/*: any*/),
                        "type": "CustomField__MultipleChoice",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "required",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "077dacf754823fecbbfefa46a3fcb4f9",
    "id": null,
    "metadata": {},
    "name": "EditForm_orderQuestions_Mutation",
    "operationKind": "mutation",
    "text": "mutation EditForm_orderQuestions_Mutation(\n  $input: FormsOrderQuestionsMutationInput!\n) {\n  orderQuestions(input: $input) {\n    form {\n      ...EditForm_form\n      id\n    }\n  }\n}\n\nfragment EditForm_form on Form {\n  id\n  isClosed\n  questions {\n    id\n    ...EditQuestionCard_formQuestion\n  }\n}\n\nfragment EditQuestionCard_formQuestion on FormQuestion {\n  id\n  ...QuestionTitle_question\n  ...QuestionInputs_question\n  ...QuestionControls_question\n}\n\nfragment QuestionControls_question on FormQuestion {\n  id\n  text\n  required\n  definition {\n    __typename\n    ... on CustomField__String {\n      id\n    }\n    ... on CustomField__Numeric {\n      minValue\n      maxValue\n    }\n    ... on CustomField__Checkboxes {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__MultipleChoice {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__Date {\n      id\n    }\n    ... on CustomField__Time {\n      id\n    }\n    ... on CustomField__DateTime {\n      id\n    }\n    ... on CustomField__PhoneNumber {\n      id\n    }\n    ... on CustomField__Email {\n      id\n    }\n    ... on CustomField__Link {\n      id\n    }\n    id\n  }\n}\n\nfragment QuestionInputs_question on FormQuestion {\n  id\n  definition {\n    __typename\n    ... on CustomField__String {\n      id\n    }\n    ... on CustomField__Numeric {\n      minValue\n      maxValue\n    }\n    ... on CustomField__Checkboxes {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__MultipleChoice {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__Date {\n      id\n    }\n    ... on CustomField__Time {\n      id\n    }\n    ... on CustomField__DateTime {\n      id\n    }\n    ... on CustomField__PhoneNumber {\n      id\n    }\n    ... on CustomField__Email {\n      id\n    }\n    ... on CustomField__Link {\n      id\n    }\n    id\n  }\n}\n\nfragment QuestionTitle_question on FormQuestion {\n  id\n  text\n  definition {\n    __typename\n    ... on CustomField__String {\n      id\n    }\n    ... on CustomField__Numeric {\n      minValue\n      maxValue\n    }\n    ... on CustomField__Checkboxes {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__MultipleChoice {\n      id\n      options {\n        value\n        text\n      }\n    }\n    ... on CustomField__Date {\n      id\n    }\n    ... on CustomField__Time {\n      id\n    }\n    ... on CustomField__DateTime {\n      id\n    }\n    ... on CustomField__PhoneNumber {\n      id\n    }\n    ... on CustomField__Email {\n      id\n    }\n    ... on CustomField__Link {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bf59324164a77f9b3a51d88508af70dc";

export default node;
